module.exports = __webpack_public_path__ + "img/card_informe_alerts.35f803ef.svg";